import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AppConfigService } from '../../../../../common/config/app.config.service';
import { CommonRoute } from '../../../../../common/enums/common-route.enum';

/**
 * The individual-or-organisation chooser only has a question to ask while
 * organisation accounts are on (ADR-0026). With them off, `/sign-up` goes
 * straight to the individual sign-up.
 *
 * A guard rather than a redirect in the chooser's `ngOnInit`: that version
 * loaded and rendered the chooser first, so Ionic animated it in and then
 * animated the real form in over it - the user saw both pages for a moment.
 * Deciding on the route means the chooser is never fetched or drawn, and
 * `/sign-up` never enters the history, so Back from the form returns to login.
 * The flag is build config, so the answer is synchronous.
 */
export const SignUpChooserGuard: CanActivateFn = () =>
  inject(AppConfigService).isOrganizationsEnabled
    ? true
    : inject(Router).createUrlTree([CommonRoute.REGISTER_INDIVIDUAL]);
